const INVITE_RETURN_URL_KEY = "inviteReturnUrl";

export function storeInviteReturnUrl(path: string): void {
    try { sessionStorage.setItem(INVITE_RETURN_URL_KEY, path); } catch { /* ignore */ }
}

export function getAndClearInviteReturnUrl(): string | null {
    try {
        const url = sessionStorage.getItem(INVITE_RETURN_URL_KEY);
        if (url) sessionStorage.removeItem(INVITE_RETURN_URL_KEY);
        return url;
    } catch { return null; }
}
